//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GridView from '@/components/GridView'
import GridViewValue from '@/components/GridViewValue'
import GridViewLabel from '@/components/GridViewLabel'
import mixin from './mixin'

export default {
  name: 'FixedWireless',

  mixins: [mixin],

  components: {
    GridViewLabel,
    GridViewValue,
    GridView
  },

  computed: {
    serviceSpeed() {
      const speed = this.service?.plan?.speed

      if (!speed) {
        return
      }

      if (speed == '1000' || speed == '10000') {
        return `${speed}mb`
      } else if (speed == '8') {
        return '8Mb / 1Mb'
      } else {
        return `${speed}Mb / ${speed}Mb`
      }
    }
  }
}
